import React, { useEffect, useState } from 'react'
import AuthUtil from '../utils/AuthUtil'

import { Redirect } from 'react-router-dom'
import AppMenu from '../components/app-menu/AppMenu'
import { isMobile, osName } from 'react-device-detect'
import logo from '../assets/images/office-free-header-logo.svg'
import as from '../assets/icons/as-icon.png'
import gp from '../assets/icons/gp-icon.png'
import Mobile from '../components/mobile/Mobile'
import useWindowDimensions from '../utils/useWindowDimensions'
import NotEnoughSize from './NotEnoughSize'

const Private = (props: any) => {
  const [mobile, setMobile] = useState(isMobile)
  const { width } = useWindowDimensions()
  useEffect(() => {
    if (mobile) {
      if (osName === 'iOS') window.location.assign('officefree://')
    }
  }, [mobile])
  return AuthUtil.isLoggedIn() ? (
    !isMobile ? (
      width < 1024 ? (
        <>
          <NotEnoughSize />
        </>
      ) : (
        <>
          <AppMenu />
          {props.children}
        </>
      )
    ) : (
      <Mobile />
    )
  ) : (
    <Redirect to={'/'} />
  )
}

export default Private
